// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__2h5sZ","additionalInfo":"AgreementModal_additionalInfo__2ASQl"};